<template>
  <div class="header-top sides-padding">
    <div class="header-top__container container">
      <a href="#" class="header-top__icon-link header-top__icon-link-city not-visible" title="Ваш город">
        <IconComponent name="location" class="icon--thick" />
        <span class="header-top__link-location">Махачкала</span>
      </a>
      <nav class="header-top__nav">
        <ul>
          <li v-for="(item, i) in list" :key="i">
            <router-link class="header-top__nav-link" :to="item.route">
              <span>{{ item.title }}</span>
              <IconComponent v-if="item.sublist && item.sublist.length" name="arrow-down-1" />
            </router-link>
            <ul v-if="item.sublist && item.sublist.length" class="header-top__subnav">
              <li v-for="(child, index) in item.sublist" :key="index">
                <router-link :to="child.route" class="header-top__nav-link">
                  {{ child.title }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <router-link
        :to="{ name: 'user', params: { link: 'profile' } }"
        class="header-top__icon-link"
        title="Вход в аккаунт"
      >
        <IconComponent name="profile" class="icon--thick" />
        <template v-if="user">
          <span v-if="user.name || user.surname"> {{ user.name }} {{ user.surname }} </span>
          <span v-else> Аноним </span>
        </template>
        <span v-else>Вход</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "HeaderTopComponent",
  data() {
    return {
      list: [
        {
          title: "О компании",
          route: { name: "about" },
          // sublist: [
          //   {
          //     title: "О компании",
          //     route: { name: "about" },
          //   },
          // ],
        },
        {
          title: "Адреса и контакты",
          route: { name: "shop" },
        },
        // {
        //   title: "Детский реестр",
        //   route: { name: "child" },
        // },
        // {
        //   title: "Школа мам",
        //   route: { name: "school" },
        // },
        {
          title: "Акции",
          route: { name: "shares" },
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.header-top {
  display flex
  align-items center
  justify-content center
  background var(--gray-light)
  color var(--main-gray)
  height 50px
  +below(768px) {
    display none
  }

  &__container {
    display flex
    align-items center
    justify-content space-between
    gap 8px
  }

  &__icon-link {
    font-weight: normal;
    font-size: 0.875em;
    line-height: 20px;
    display inline-flex
    align-items center
    color var(--main-gray)

    .icon {
      width 42px
      height 42px
      padding 11px
    }

		&-city {
			//opacity 0
		}
  }

  &__link-location {
    border-bottom: 1px dashed var(--main-gray)
  }

  &__nav {
    display inline-flex
    align-items center
    font-weight: normal;
    font-size: 0.875em;
    line-height: 20px;

    > ul {
      display flex
      align-items center

      li {
        position relative

        &:hover > .header-top__subnav {
          opacity: 1;
          visibility visible
          pointer-events auto
        }
      }
    }

    &-link {
      position relative
      padding 16px 15px
      color var(--main-gray)
      display flex
      align-items center
      gap 5px

      .icon {
        width 10px
        height 10px
      }
    }
  }

  &__subnav {
    position absolute
    top calc(100% - 1px);
    left 0
    background var(--white)
    z-index: 2;
    border-radius: var(--main_radius)
    min-width 250px
    box-shadow: 0 15px 40px var(--black_o15)
    opacity 0
    visibility hidden
    pointer-events none
    transition var(--transition)

    li:not(:last-child) {
      border-bottom 1px solid var(--gray);
    }

    .header-top__nav-link {
      padding 10px 15px
      white-space nowrap
    }
  }
}
</style>
